<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {}
  },
  beforeCreate() {
    // 添加推广来源
    // localStorage.setItem('popularizeSource', this.$route.query.sourceId || '')

    console.log(
      'setPopularizeSource',
      decodeURI(this.$route.query.sourceId || '')
    )
    this.$store.commit(
      'auth/setPopularizeSource',
      decodeURI(this.$route.query.sourceId || '')
    )
    this.$router.replace(this.$route.query.redirect || '/')
  }
}
</script>
